/**
 * auth-relay の signInWithEmailLink が返すエラーコード（cmp-pjt-back#229）を、
 * 画面に出す文言と表示先に変換する。
 *
 * - "form": メールアドレス入力画面に留まり、入力し直してもらう
 * - "link": リンク自体が使えないので、再送画面（/signin-email）への導線を出す
 */
export type EmailLinkErrorView = {
  message: string;
  target: "form" | "link";
};

const LINK_RESEND_GUIDE =
  "お手数ですが、アカウント設定メールを再送し、届いたメールのリンクからアカウント設定をやり直してください。";

const INVALID_LINK_ERROR: EmailLinkErrorView = {
  message: `このリンクは無効、またはすでに使用されています。${LINK_RESEND_GUIDE}アカウント設定が完了している場合はサインインしてください。`,
  target: "link",
};

const EMAIL_LINK_ERRORS: Record<string, EmailLinkErrorView> = {
  "email-mismatch": {
    message: "メールアドレスが登録案内の送信先と一致しません。",
    target: "form",
  },
  "invalid-email": {
    message: "メールアドレスの形式が正しくありません。",
    target: "form",
  },
  "invalid-link": INVALID_LINK_ERROR,
  "expired-link": {
    message: `このリンクは有効期限が切れています。${LINK_RESEND_GUIDE}`,
    target: "link",
  },
  "user-disabled": {
    message: "このアカウントは現在ご利用いただけません。",
    target: "form",
  },
};

const FALLBACK_ERROR: EmailLinkErrorView = {
  message: "認証に失敗しました。時間をおいて再度お試しください。",
  target: "form",
};

export const getEmailLinkError = (code: string | undefined): EmailLinkErrorView =>
  (code && EMAIL_LINK_ERRORS[code]) || FALLBACK_ERROR;
